module.exports = __webpack_public_path__ + "static/media/service-design.9a483c87.svg";